import Backbone from 'backbone'
import _ from 'lodash'
import Tooltip from 'scoreboard/components/tooltip'
import $ from 'jquery'

const FeatureView = Backbone.View.extend({

	className: 'feature-view porter-package porter-destination no-drag',

	tagName: 'li',

	events: {
		'dropShadow': 'onDropShadow',
		'drag': 'onDrag',
		'mousedown': 'applyWidth',
		'touchstart': 'applyWidth',
		'mouseleave': 'removeWidth',
		'touchend': 'removeWidth',
		'mouseenter .drag-handle': 'toggleDrag',
		'mouseleave .drag-handle': 'toggleDrag',
		'mouseenter .error-display svg': 'onErrorTooltipMouseEnter',
		'mouseleave .error-display svg': 'removeErrorTooltip'
	},

	/**
	 * @type ChartDesignerFeature (Serie, Analytic)
	 */
	model: null,

	/**
	 * @property
	 * @type ChartDesigner
	 */
	chart: null,

	/**
	 *
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {ChartDesignerFeature} options.model
	 */
	initialize: function(options = {}) {
		this.options = options
		this.chart = options.chart
		this.el.parentFeatureModel = options.parentFeatureModel
		this.topDropzone = options.topDropzone
		this.bottomDropzone = options.bottomDropzone

		this.listenTo(this.model, 'change', () => this.paint())

		this.listenTo(this.model, 'change:error', () => {
			this.renderErrorState()
		})

		this.listenTo(this.model.children, 'update', () => {
			this.renderErrorState()
		})
	},

	render: function() {
		this.renderContent()
		this.paint()

		this.$el.parent().on('removeEditTooltip', () => {
			this.removeEditTooltip()
		})

		//for porter
		this.$el.attr('data-id', this.cid)
		this.el.featureModel = this.model

		this.setHeight()

		let isFilledMapPlotType = this.model.get('plotType') === 'filled-map'
		if (isFilledMapPlotType) {
			this.$('.grip-container').remove()
		}

		// if there is no specified area for dragging, the whole feature should
		// be draggable
		// If the plotType is a filled-map, it shouldn't be draggable at all because
		// it's the only feature-view on screen
		const noDragHandle = _.isNil(this.$('.drag-handle')[0])
		if (noDragHandle && !isFilledMapPlotType) this.$el.removeClass('no-drag')

		return this
	},

	/**
	 * Render content that is needed initially but not on each paint()
	 * @abstract
	 */
	renderContent: function() {},

	/**
	 * Updates the UI with the latest feature config; works either on initial
	 * render or on update.
	 * @abstract
	 */
	paint: function() {},

	/**
	 * Items that can have variable heights need to have a fixed height value
	 * so that transitions can work properly. We can easily achieve this by
	 * grabbing the hidden `.active-content` height on load. Because the inactive
	 * state shows for all panels on load, we don't have to do anything fancy
	 * to get the heights like waiting to reveal content while calculating heights.
	 */
	setHeight: function() {
		let hiddenContentHeight = this.$('.active-content').height()
		this.$el.height(hiddenContentHeight)
	},

	/**
	 * On mousedown, we'll grab its width and apply it as a fixed width. This
	 * traveling dragged item to keep the same width since the node is copied over.
	 */
	applyWidth: function() {
		this.viewWidth = this.$el.outerWidth()
		this.$el.css('max-width', `${this.viewWidth}px`)
	},

	/*
	 * When the mouse leaves the feature view, remove the fixed width so it can
	 * transition back down to its badge size and also be responsive to display
	 * pane resizng.
	 */
	removeWidth: function() {
		this.$el.css('width', '')
	},

	/**
	 * Called by subclasses anytime an event occurs that results in a (bootslide)
	 * edit menu being shown.
	 *
	 * @param {Event} e the DOM event
	 */
	onEdit: function(e) {
		e.stopPropagation()

		// remove this tooltip and all other feature tooltips
		this.trigger('edit')

		let attachTo = this.attachTooltipTo || this.$el
		// using closest li instead of this.$el so it is attached to what the
		// user clicked on (e.g. line, fill, etc)
		if (e.target !== this.el && !this.attachTooltipTo) { // this is true of serie items
			attachTo = this.$(e.target).closest('li')
		}

		let editMenu = this.createEditMenu(e)
		this.listenTo(editMenu, 'loading', () => this.trigger('loading'))

		this.editTooltip = new Tooltip({
			attachTo,
			// up to base class to inspect the event and show the right content
			content: editMenu,
			placement: 'right',
			arrow: 'top',
			extraClass: 'has-bootslide-menu chart-designer-tooltip'
		}).render()
	},

	/**
	 * @abstract
	 * @param {Event} e the DOM event that triggered the menu to be shown
	 */
	createEditMenu: function(e) {},

	inactive: function () {
		this.removeEditTooltip()
	},

	/**
	 * A feature view could show multiple types of tooltips (e.g. lines and fills)
	 * but will only ever have one tooltip active at a time.
	 */
	removeEditTooltip: function () {
		this.editTooltip && this.editTooltip.remove()
	},

	onDropShadow(e, arg) {
		e.stopPropagation()
		const notInSerie = this.model.get('type') != 'serie'
		const topDropzone = this.topDropzone
		const bottomDropzone = this.model.get('type') == 'stack' ?
			this.dropzones[0] : this.bottomDropzone

		if (!arg.show || (notInSerie && !$(e.target).hasClass('porter-wrapper'))) {
			return
		}

		const bottomShowing = bottomDropzone.isShowing()
		const topShowing = topDropzone.isShowing()

		// we only want one dropzone active at a time, so hide all the
		// other ones in the same axis panel
		this.$el.closest('.y-axis-panel').find('.dropzone').removeClass('is-selected')

		// show the top if bottom is showing and vice versa,
		// if neither are showing, show what is indicated by position
		let showTop = bottomShowing
		let showBottom = topShowing
		if (!(bottomShowing || topShowing)) {
			showTop = arg.top
			showBottom = !arg.top
		}
		bottomDropzone.toggleVisibility(showBottom)
		topDropzone.toggleVisibility(showTop)
	},

	/**
	 * When starting a drag of a feature, places an initial dropzone underneath
	 * of it
	 */
	displayTemporaryDropzone() {
		this.topDropzone.showInactiveText()
		this.topDropzone.toggleVisibility(true)

		let isOnlyChild = this.isOnlyChild()
		let activeClass = isOnlyChild ?
			'temporarily-active' : 'is-selected'
		this.topDropzone.$el.addClass(activeClass)
		isOnlyChild && this.bottomDropzone.$el.addClass('is-not-displayed')
	},

	/**
	 * If the feature has a parent and is its only child
	 */
	isOnlyChild: function() {
		const parentChildren = _.get(this.options,
			'parentFeatureModel.children')
		return !_.isNil(parentChildren) && parentChildren.length == 1
	},

	onDrag: function(e, active) {
		// remove edit menus on drag
		this.trigger('edit')
		this.model.dragging = active
		this.$el.toggleClass('is-not-displayed', active)
		e.stopPropagation()
	},

	/**
	 * toggles the ability to drag the feature when the mouse leaves or enters
	 * the drag-handle
	 */
	toggleDrag: function(e) {
		this.$el.toggleClass('no-drag', e.type === 'mouseleave')
	},

	renderErrorState () {
		this.$el.toggleClass('has-error', this.model.hasError())
	},

	onErrorTooltipMouseEnter: function (e) {
		this.errorTooltip = new Tooltip({
			attachTo: $(e.currentTarget),
			content: () => {
				let error = $(e.target).parents('.error-display')
					.attr('data-error-message')
				return _.escape(error)
			},
			placement: 'above',
			arrow: 'center'
		}).render()
	},

	removeErrorTooltip: function () {
		this.errorTooltip && this.errorTooltip.remove()
		delete this.errorTooltip
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		this.removeEditTooltip()
		this.removeErrorTooltip()
	}
})

export default FeatureView

FeatureView.__filename__ = 'charts/edit/feature-view.js'
